import { FormGroup } from '@components/async-form';
import { useState } from 'preact/hooks';
import { Toggle } from '@components/toggle';
import { rpx } from 'client/lib/rpx-client';
import dayjs from 'dayjs';
import { DateInput } from '@components/date-picker';
import { ModalForm } from '@components/modal-form';
import { useCurrentTenant } from 'client/lib/auth';

interface Props {
  courseId: UUID;
  hide(): void;
  onSuccess: (updatedCount: number) => void;
}

const store = rpx.manageStudents;

export function BulkExpirationModal({ courseId, hide, onSuccess }: Props) {
  const terminology = useCurrentTenant().terminology;
  const [currentDate, setCurrentDate] = useState<Date | undefined>(undefined);

  async function setBulkExpiration(formData: { notifyStudents: boolean }) {
    if (!currentDate) {
      throw new Error('Please select an expiration date');
    }

    const newExpiresAt = dayjs(currentDate).startOf('day').toISOString();

    const result = await store.setBulkExpirationDate({
      courseId,
      expiresAt: newExpiresAt,
      notifyStudents: formData.notifyStudents,
    });

    onSuccess(result.updatedCount);
  }

  return (
    <ModalForm
      onClose={hide}
      onSubmit={setBulkExpiration}
      title="Bulk set student expiration date"
      confirmButtonText="Save"
      autoFocus={false}
    >
      <p class="mb-2 text-gray-600">
        This will set the expiration date for all active students in the {terminology.course}.
      </p>

      <FormGroup prop="expiresAt">
        <label class="block mb-2 font-medium">Set expiration date:</label>
        <DateInput value={currentDate} onChange={setCurrentDate} min={new Date()} />
      </FormGroup>

      <label class="flex items-center gap-3 mt-1 font-medium">
        <Toggle name="notifyStudents" defaultChecked />
        Notify students with an email
      </label>
    </ModalForm>
  );
}
